import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
	jobPostingsGet,
	jobPostingGetById,
	jobPostingCreate,
	jobPostingUpdate,
	jobPostingDelete
} from "api/menu/hr/job-postings/requests";

export const FETCH_JOB_POSTINGS_SUCCESS = "FETCH_JOB_POSTINGS_SUCCESS";
export const FETCH_JOB_POSTING_BY_ID_SUCCESS = "FETCH_JOB_POSTING_BY_ID_SUCCESS";

export const JOB_POSTINGS_REQUEST_LOADING = "JOB_POSTINGS_REQUEST_LOADING";
export const JOB_POSTINGS_REQUEST_ERRORS = "JOB_POSTINGS_REQUEST_ERRORS";

export const setLoading = () => ({ type: JOB_POSTINGS_REQUEST_LOADING });

export const fetchJobPostings = (includeInactive = false) => dispatch => {
	dispatch(setLoading());
	jobPostingsGet(includeInactive)
		.then(response => {
			dispatch({ type: FETCH_JOB_POSTINGS_SUCCESS, payload: response.data });
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, JOB_POSTINGS_REQUEST_ERRORS));
		});
};

export const fetchJobPostingById = (id) => dispatch => {
	jobPostingGetById(id)
		.then(response => {
			dispatch({ type: FETCH_JOB_POSTING_BY_ID_SUCCESS, payload: response.data });
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, JOB_POSTINGS_REQUEST_ERRORS));
		});
};

export const createJobPosting = (data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	jobPostingCreate(data)
		.then(response => {
			dispatch(formErrorLoading(false));
			toast(`Job Posting "${data.title}" created`, { type: toast.TYPE.SUCCESS });
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const updateJobPosting = (id, data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	jobPostingUpdate(id, data)
		.then(() => {
			dispatch(formErrorLoading(false));
			toast(`Job Posting "${data.title}" updated`, { type: toast.TYPE.SUCCESS });
			if (callback) callback(true);
		})
		.catch(error => {
			dispatch(formErrorLoading(false));
			if (callback) callback(error);
		});
};

export const deleteJobPosting = (id, title, callback = false) => dispatch => {
	dispatch(setLoading());
	jobPostingDelete(id)
		.then(() => {
			toast(`Job Posting "${title}" deleted`, { type: toast.TYPE.SUCCESS });
			if (callback) callback();
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, JOB_POSTINGS_REQUEST_ERRORS));
		});
};

export const clearJobPostings = () => dispatch => {
	dispatch({ type: FETCH_JOB_POSTINGS_SUCCESS, payload: [] });
};

export const clearSingleJobPosting = () => dispatch => {
	dispatch({ type: FETCH_JOB_POSTING_BY_ID_SUCCESS, payload: {} });
};


